import { type FC } from 'react';

import { LoadingPage } from '#packages/web/layouts/page/templates';

/**
 * This page is displayed during the initialization of the app.
 */
export const InitPageRenderer: FC = () => <LoadingPage />;
